import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../../../../../RMS/Components/Layout/Header";

import Progress from "./Progress";
import {
  faArrowLeft,
  faArrowRight,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Style/Style.css";
import { useRef } from "react";
import axiosInstance from "../../../../../../../../../store/axiosInstance";
import { SERVER_URL } from "../../../../../../../../../Config/config";

// CareerRoadmap Component
const CareerRoadmap = () => {
  const { state } = useLocation();
  const [roadmapData, setRoadmapData] = useState(state.roadmap || null);
  // const [roadmapData, setRoadmapData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  console.log("roadmapData", roadmapData);

  // useEffect(() => {
  //   const fetchRoadmap = async () => {
  //     try {
  //       const response = await fetch("/api/v1/roadmap");
  //       if (!response10response.ok) {
  //         throw new Error("Failed to fetch roadmap data");
  //       }
  //       const data = await response.json();
  //       setRoadmapData(data);
  //       setLoading(false);
  //     } catch (err) {
  //       setError(err.message);
  //       setLoading(false);
  //     }
  //   };
  //   fetchRoadmap();
  // }, []);

  // if (loading) {
  //   return <div className="text-white text-center">Loading...</div>;
  // }

  // if (error) {
  //   return <div className="text-red-500 text-center">Error: {error}</div>;
  // }

  return (
    <div className="w-full h-full bg-black bg-Fabcbg bg-cover bg-center">
      <Header />
      <div className="md:p-10 p-3">
        <div className="bg-[#D9D9D915] rounded-lg border border-[#3EE6F93B] w-full overflow-hidden">
          <Hero roadmap={roadmapData?.roadmap} />
          <ProfileMatch skillMatch={roadmapData?.roadmap?.skillMatch} />
          <RoadmapTimeline timelines={roadmapData?.roadmap?.timelines} />
          <UpskillingSuggestions
            requiredSkills={roadmapData?.roadmap?.requiredSkills}
            courses={{
              beginner: roadmapData?.roadmap?.beginner?.courses || [],
              intermediate: roadmapData?.roadmap?.intermediate?.courses || [],
              advanced: roadmapData?.roadmap?.advanced?.courses || [],
            }}
          />
          <ProjectSuggestions
            projects={{
              beginner: roadmapData?.roadmap?.beginner?.projectIdeas || [],
              intermediate:
                roadmapData?.roadmap?.intermediate?.projectIdeas || [],
              advanced: roadmapData?.roadmap?.advanced?.projectIdeas || [],
            }}
          />
          <FooterCareerMap
            futureRoles={roadmapData?.roadmap?.futureRoles}
            requiredSkills={roadmapData?.roadmap?.requiredSkills}
            skillCategories={roadmapData?.roadmap?.skillCategories}
          />
        </div>
      </div>
    </div>
  );
};

// Hero Component
const Hero = ({ roadmap }) => {
  const careerGoal = roadmap?.futureRoles?.[0]?.Title || "Unknown";
  const profileDescription =
    roadmap?.profileDescription || "No description available";

  return (
    <div className="w-full text-white px-6 py-12 relative">
      <div className="absolute w-full flex justify-between z-0">
        <div
          style={{
            background:
              "radial-gradient(50% 50% at 50% 50%, rgba(158, 110, 230, 0.28) 0%, rgba(158, 110, 230, 0) 100%)",
          }}
          className="w-[45rem] h-[35rem] opacity-45 blur rounded-full"
        ></div>
        <div
          style={{
            background:
              "radial-gradient(50% 50% at 50% 50%, rgba(92, 195, 250, 0.28) 0%, rgba(92, 195, 250, 0) 100%)",
          }}
          className="w-[45rem] h-[35rem] opacity-45 blur rounded-full"
        ></div>
      </div>
      <div className="w-full mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-2xl md:text-3xl font-bold mb-2">
            Career Roadmap <span className="text-[#00FF2F]">{careerGoal}</span>
          </h1>
        </div>
        <div className="flex flex-col lg:flex-row items-center justify-center gap-12 mt-14">
          <div className="relative gap-10 lg:gap-5 flex lg:flex-row flex-col justify-center items-center">
            <div className="lg:w-[40%]">
              <img src="/assets/Mascots/mas5.svg" className="w-6/12 mx-auto" />
            </div>
            <div className="lg:w-[60%] w-[90%] mx-auto text-center lg:text-left">
              <div className="mb-10">
                <h2 className="text-xl font-bold mb-2">
                  FABC ID: <span className="ml-3 text-yellow-400">DxYU6SL</span>
                </h2>
                <p className="text-gray-300 text-sm mt-5 leading-relaxed">
                  {profileDescription}
                </p>
              </div>
              <div className="">
                <div className="flex md:flex-row flex-col items-center gap-3">
                  <Progress
                    percentage={
                      roadmap?.skillMatch?.overallMatchPercentage || 0
                    }
                    color="#06DA34"
                  />
                  <div>
                    <p className="text-base font-light">
                      Your Profile Matches only{" "}
                      {roadmap?.skillMatch?.overallMatchPercentage || 0}% for{" "}
                      {careerGoal}
                    </p>
                    <p className="text-sm mt-2 font-light italic underline cursor-pointer">
                      Download full report
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ProfileMatch Component
const ProfileMatch = ({ skillMatch }) => {
  const skills = [
    {
      title: "Skill",
      percentage: skillMatch?.skillsMatchPercentage || 0,
      color: "#10b981",
      bgcolor1: "#C9E42F70",
      bgcolor2: "#392002",
    },
    {
      title: "Project",
      percentage: skillMatch?.projectsMatchPercentage || 0,
      color: "#06b6d4",
      bgcolor1: "#00F74270",
      bgcolor2: "#034D1B",
    },
    {
      title: "Experience",
      percentage: skillMatch?.experienceMatchPercentage || 0,
      color: "#eab308",
      bgcolor1: "#51CBFF70",
      bgcolor2: "#A70E0E80",
    },
    {
      title: "Personality",
      percentage: skillMatch?.personalityMatchPercentage || 0,
      color: "#a855f7",
      bgcolor1: "#7707FF70",
      bgcolor2: "#FC070770",
    },
  ];

  return (
    <div className="text-white px-6 pt-10 pb-20 relative">
      <div className="absolute w-full flex justify-between z-0">
        <div
          style={{
            background:
              "radial-gradient(50% 50% at 50% 50%, rgba(252, 7, 7, 0.18) 0%, rgba(252, 7, 7, 0) 100%)",
          }}
          className="w-[45rem] h-[35rem] opacity-25 blur rounded-full"
        ></div>
        <div
          style={{
            background:
              "radial-gradient(50% 50% at 50% 50%, rgba(119, 7, 255, 0.28) 0%, rgba(119, 7, 255, 0) 100%)",
          }}
          className="w-[45rem] h-[35rem] opacity-25 blur rounded-full"
        ></div>
      </div>
      <div className="w-full mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold mb-2">
            Profile Match for the role
          </h2>
          <p className="text-gray-300 text-sm">
            Your Profile Matches only {skillMatch?.overallMatchPercentage || 0}%
            for {skillMatch?.futureRoles?.[0]?.Title || "Unknown"}
          </p>
        </div>
        <div className="md:w-[80%] w-[95%] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-20">
          {skills.map((skill, index) => (
            <div
              key={index}
              className="rounded-3xl p-[1px]"
              style={{
                backgroundImage: `linear-gradient(to right, ${skill.bgcolor1}, ${skill.bgcolor2})`,
              }}
            >
              <div className="bg-[#281f28] py-6 rounded-3xl text-center flex flex-col justify-center items-center">
                <h3 className="text-white text-sm font-semibold mb-10 press-start-2p-regular">
                  {skill.title}
                </h3>
                <Progress percentage={skill.percentage} color={skill.color} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// RoadmapTimeline Component
const RoadmapTimeline = ({ timelines }) => {
  const [selectedLevel, setSelectedLevel] = useState("threeMonth");
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);

  const roadmapData = {
    threeMonth: timelines?.threeMonth?.months || [],
    sixMonth: timelines?.sixMonth?.months || [],
    twelveMonth: timelines?.twelveMonth?.months || [],
  };

  const months = roadmapData[selectedLevel];

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0);
    }
  }, [selectedLevel]);

  const handleLevelChange = (e) => {
    setSelectedLevel(e.target.value);
    setCurrentSlide(0);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0);
    }
  };

  const CustomArrow = ({ direction, onClick }) => (
    <button
      onClick={onClick}
      className={`absolute top-20 z-10 px-4 py-2 bg-[#3F3F3F] ${
        direction === "left" ? "-left-12" : "-right-12"
      }`}
    >
      <FontAwesomeIcon
        icon={direction === "left" ? faArrowLeft : faArrowRight}
      />
    </button>
  );

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: Math.min(4, months.length || 1),
    slidesToScroll: 1,
    beforeChange: (_, newIndex) => setCurrentSlide(newIndex),
    prevArrow: months.length > 1 ? <CustomArrow direction="left" /> : null,
    nextArrow: months.length > 1 ? <CustomArrow direction="right" /> : null,
    customPaging: (i) => (
      <div
        className={`w-3 h-3 rounded-full ${
          i === currentSlide ? "bg-[#FFBA00]" : "bg-gray-600"
        }`}
      />
    ),
    appendDots: (dots) => (
      <div className="mt-8">
        <ul className="flex justify-center gap-2">{dots}</ul>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1280,
        settings: { slidesToShow: Math.min(3, months.length || 1) },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: Math.min(2, months.length || 1) },
      },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="text-white bg-black/80 rounded-lg px-6 py-12">
      <div className="text-center mb-8 ">
        <div className=" flex justify-center items-center gap-3 mb-4">
        <h2 className="text-2xl font-bold ">Roadmap</h2>
          <select
            className="z-30 cursor-pointer bg-transparent text-[#FFBA00] text-lg focus:outline-none"
            value={selectedLevel}
            onChange={handleLevelChange}
          >
            <option value="threeMonth" className=" bg-black text-white text-sm ">3 Months</option>
            <option value="sixMonth" className=" bg-black text-white text-sm ">6 Months</option>
            <option value="twelveMonth" className=" bg-black text-white text-sm ">12 Months</option>
          </select>
        </div>
        <p className="text-gray-300 text-sm">
          Your Profile Matches only 30% for Web3 Digital Marketer
        </p>
      </div>

      <div className="relative">
        <div className="absolute top-[142px] left-0 right-0 border border-white/80 border-dashed z-0" />
        <div className="relative px-7 z-10">
          {months.length > 0 ? (
            <Slider ref={sliderRef} {...sliderSettings}>
              {months.map((monthData, index) => (
                <div key={index} className="pt-32 px-4">
                  <div className="relative">
                    {index === currentSlide && (
                      <img
                        src="/assets/Mascots/mas5.svg"
                        className="w-10 mx-auto absolute -top-20 left-1/2 -translate-x-1/2"
                      />
                    )}
                    <div className="flex flex-col items-center">
                      <div
                        className={`w-7 h-7 rounded-full border-[3px] mb-2 flex items-center justify-center ${
                          index === 0 ? "border-[#09FF0087]" : "border-gray-700"
                        }`}
                      >
                        <div className="w-3 h-3 border-2 border-[#0DFF42] rounded-full" />
                      </div>
                    </div>
                  </div>
                  <div className="mt-7 flex flex-col items-center">
                    <h3 className="text-sm font-bold mb-5">
                      Month {monthData.month}
                    </h3>
                    <ul className="space-y-3 list-disc">
                      {monthData.skills.map((skill, i) => (
                        <li
                          key={i}
                          className="flex items-center justify-between gap-2"
                        >
                          <span className="text-sm">{skill}</span>
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            className="text-white/60 text-sm"
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </Slider>
          ) : (
            <div className="text-center text-gray-300">
              No timeline data available for this duration.
            </div>
          )}
        </div>
      </div>

      <div className="flex md:flex-row flex-col justify-center gap-7 mt-14">
        <button className="bg-[#D9D9D960] px-7 py-2 rounded-full font-medium text-sm italic">
          Validate Now
        </button>
        <button className="border border-white/80 px-6 py-2 rounded-full font-medium text-sm">
          Download report
        </button>
      </div>
    </div>
  );
};

// UpskillingSuggestions Component
const UpskillingSuggestions = ({ requiredSkills, courses }) => {
  const [activeDropdown, setActiveDropdown] = useState(
    requiredSkills?.[0]?.skill || ""
  );

  const courseData = requiredSkills.reduce((acc, skill) => {
    const relatedCourses = [
      ...courses.beginner.filter((c) => c.skillsCovered.includes(skill.skill)),
      ...courses.intermediate.filter((c) =>
        c.skillsCovered.includes(skill.skill)
      ),
      ...courses.advanced.filter((c) => c.skillsCovered.includes(skill.skill)),
    ];
    return { ...acc, [skill.skill]: relatedCourses };
  }, {});

  const toggleDropdown = (category) => {
    setActiveDropdown(activeDropdown === category ? null : category);
  };

  return (
    <div className="text-white px-6 py-12">
      <div className="w-full flex lg:flex-row flex-col items-center mx-auto lg:gap-0 gap-10">
        <div className="lg:w-[40%]">
          <h2 className="text-2xl lg:text-left text-center font-bold mb-4">
            Upskilling <span className="text-yellow-400">Suggestion</span>
          </h2>
          <p className="text-gray-300 text-sm">
            Your Profile Matches only <span className="font-bold">30%</span> for
            Web3 Digital Marketer
          </p>
        </div>

        <div className="lg:w-[60%] w-full">
          <div className=" h-[30rem] overflow-y-auto mx-auto mb-10 space-y-5">
            {requiredSkills.map((skill) => (
              <div
                key={skill.skill}
                className="bg-[#D9D9D91A] rounded-2xl overflow-hidden"
              >
                <button
                  onClick={() => toggleDropdown(skill.skill)}
                  className="w-full rounded-2xl bg-[#D9D9D925] flex items-center justify-between p-4 text-left transition-colors border border-[#37FEA4]/60"
                >
                  <span className="w-full font-semibold text-center">
                    {skill.skill}
                  </span>
                </button>

                {activeDropdown === skill.skill && (
                  <div className="">
                    <div className="p-4">
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        {courseData[skill.skill].map((course, index) => (
                          <div
                            key={index}
                            className="rounded-lg overflow-hidden"
                          >
                            <div
                              style={{
                                backgroundImage: `url(/assets/Others/upskill${
                                  (index % 3) + 1
                                }.svg)`,
                              }}
                              className="bg-cover bg-center h-56 flex items-start justify-start "
                            >
                              <div className="p-3 w-full bg-black/40 h-full flex flex-col items-end justify-start ">
                                <h4 className="font-semibold  w-full text-left text-base mb-1">
                                  {course.title}
                                </h4>
                                <p className="w-full text-left text-sm font-semibold">
                                  <span className="font-light mr-3">
                                    Duration:
                                  </span>
                                  {course.durationInWeeks} weeks
                                </p>
                                <p className="w-full text-left text-sm font-semibold">
                                  <span className="font-light mr-3">
                                    Provider:
                                  </span>
                                  {course.platform}
                                </p>
                                <div className="w-full mt-2">
                                  {course.searchUrls.map((url, urlIndex) => (
                                    <a
                                      key={urlIndex}
                                      href={url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="gap-3 text-FABcYellow flex items-center mt-3 "
                                    >
                                      <p>Start Here</p>
                                      <div className="w-5 h-5 border  rounded-full flex items-center justify-center">
                                        <FontAwesomeIcon  className="-rotate-45 text-sm" icon={faArrowRight} />
                                        </div>
                                    </a>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="flex items-start justify-center gap-4">
            <p className="text-xs font-medium italic ">Scroll for more courses</p>
            <div className="text-xs flex flex-col items-center animate-bounce ">
              <FontAwesomeIcon icon={faChevronUp} className="" />
              <FontAwesomeIcon icon={faChevronUp} className=" -translate-y-2 "/>
              <FontAwesomeIcon icon={faChevronUp} className=" -translate-y-4  "/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ProjectSuggestions Component
const ProjectSuggestions = ({ projects }) => {
  const projectCategories = [
    {
      title: "For Beginners",
      projects: projects.beginner,
    },
    {
      title: "For Intermediate",
      projects: projects.intermediate,
    },
    {
      title: "For Experts",
      projects: projects.advanced,
    },
  ];

  const getDifficultyColor = (index) => {
    switch (index) {
      case 0:
        return "bg-green-500";
      case 1:
        return "bg-yellow-500";
      case 2:
        return "bg-red-500";
      default:
        return "bg-gray-500";
    }
  };

  return (
    <div className="text-white sm:px-6 px-3 py-12 relative">
      <div className="absolute w-full flex justify-between z-0">
        <div
          style={{
            background:
              "radial-gradient(50% 50% at 50% 50%, rgba(167, 14, 14, 0.28) 0%, rgba(167, 14, 14, 0) 100%)",
          }}
          className="w-[50rem] h-[35rem] opacity-25 blur rounded-full"
        ></div>
        <div
          style={{
            background:
              "radial-gradient(50% 50% at 50% 50%, rgba(92, 195, 250, 0.28) 0%, rgba(92, 195, 250, 0) 100%)",
          }}
          className="w-[50rem] h-[35rem] opacity-20 blur rounded-full"
        ></div>
      </div>
      <div className="mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold mb-2">
            Project <span className="text-[#FFBA00]">Suggestion</span>
          </h2>
          <p className="text-gray-300 text-sm">
            Your Profile Matches only 30% for Web3 Digital Marketer
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-14 h-full z-30 ">
          {projectCategories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="space-y-4 h-full">
              <h3 className="text-base font-medium text-center mb-6">
                {category.title}
              </h3>

              <div className="space-y-4 h-full">
                {category.projects.map((project, projectIndex) => (
                  <div
                    key={projectIndex}
                    className="bg-[#D9D9D917] rounded-lg p-6 hover:bg-gray-750 transition-colors "
                  >
                    <div className="flex items-start justify-between mb-3">
                      <h4 className="font-semibold text-lg">{project.title}</h4>
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium ${getDifficultyColor(
                          categoryIndex
                        )}`}
                      >
                        {categoryIndex === 0
                          ? "Easy"
                          : categoryIndex === 1
                          ? "Medium"
                          : "Hard"}
                      </span>
                    </div>

                    <p className="text-gray-300 text-sm mb-4">
                      {project.description}
                    </p>

                    <div className="flex items-center justify-between">
                      <span className="text-xs text-gray-400">
                        Duration: 2 weeks
                      </span>
                      {/* <button className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-lg text-sm font-medium transition-colors">
                        Start Project
                      </button> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// FooterCareerMap Component
const FooterCareerMap1 = ({ futureRoles, requiredSkills }) => {
  const careerPaths =
    futureRoles?.reduce(
      (acc, role) => ({
        ...acc,
        [role.Title]: {
          skills: requiredSkills?.slice(0, 3).map((s) => s.skill) || [],
          experience: ["3+ years experience"],
          salary: [role.SalaryRange],
          requirements: [
            "3+ years of experience",
            "Strong portfolio",
            "Team collaboration",
          ],
        },
      }),
      {}
    ) || {};

  const developmentAreas = {
    Web3:
      requiredSkills
        ?.filter((s) =>
          [
            "NFT Marketing",
            "DAO Marketing",
            "DeFi Marketing",
            "Tokenomics",
          ].includes(s.skill)
        )
        .map((s) => s.skill) || [],
    DigitalMarketing:
      requiredSkills
        ?.filter((s) =>
          [
            "Email Marketing",
            "Social Media Marketing",
            "Influencer Marketing",
            "Affiliate Marketing",
          ].includes(s.skill)
        )
        .map((s) => s.skill) || [],
    Analytics:
      requiredSkills
        ?.filter((s) =>
          ["Attribution Modeling", "Customer Segmentation"].includes(s.skill)
        )
        .map((s) => s.skill) || [],
    SoftSkills:
      requiredSkills
        ?.filter((s) =>
          ["Teamwork", "Adaptability", "Creativity", "Leadership"].includes(
            s.skill
          )
        )
        .map((s) => s.skill) || [],
  };

  return (
    <div className="bg-[#1B1A1AB8] rounded-xl text-white px-2 md:px-6 py-12 m-2 sm:m-7">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl font-bold mb-6">
              Career <span className="text-yellow-400">Map</span>
            </h2>

            <div className="relative mb-6">
              <input
                type="text"
                placeholder="Search for career paths..."
                className="w-full bg-[#D9D9D92E] border border-[#BFBFBF] rounded-xl px-5 py-2 text-white placeholder-white focus:outline-none focus:border-blue-500 placeholder:italic placeholder:text-xs"
              />
            </div>

            <div className="space-y-4">
              {Object.entries(careerPaths).map(([role, data], index) => (
                <div key={index} className="rounded-lg p-4">
                  <h3 className="font-semibold mb-4">
                    Role: <span className="font-light ml-2">{role}</span>
                  </h3>
                  <div className="space-y-4">
                    <div className="flex md:flex-row flex-col items-start md:items-center gap-2">
                      <span className="font-semibold">Average Salary:</span>
                      <span className="font-light">
                        {data.salary.join(", ")}
                      </span>
                    </div>
                    <div className="flex md:flex-row flex-col items-start md:items-center gap-2">
                      <span className="font-semibold">Key Skills:</span>
                      <span className="font-light">
                        {data.skills.join(", ")}
                      </span>
                    </div>
                    <div className="flex md:flex-row flex-col items-start md:items-center gap-2">
                      <span className="font-semibold">Requirements:</span>
                      <span className="font-light">
                        {data.requirements.join(", ")}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-[#4747474F] h-full rounded-xl p-5">
            <div className="flex flex-col items-center justify-center">
              <h2 className="text-2xl font-bold mb-6">
                <span>{futureRoles?.[0]?.Title || "Unknown"}</span>
              </h2>

              <div className="w-full h-[25rem] overflow-y-auto text-white flex flex-col items-center justify-center space-y-5 relative">
                <div className="absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-px bg-white/50" />
                {Object.entries(developmentAreas).map(
                  ([area, skills], index) => (
                    <div
                      key={index}
                      className="flex items-start justify-around w-full gap-4"
                    >
                      <div className="w-[45%] text-white">
                        <h3 className="font-semibold mb-2">{area}</h3>
                      </div>
                      <div className="flex flex-col items-center justify-center">
                        <div className="w-5 h-5 rounded-full border-[3px] border-[#09FF0087] flex items-center justify-center shadow-[0_0_6px_#0DFF42]">
                          <div className="w-2 h-2 bg-[#0DFF42] rounded-full" />
                        </div>
                      </div>
                      <ul className="w-[45%] sm:pl-10 pl-0 text-white space-y-2">
                        {skills.map((skill, skillIndex) => (
                          <li
                            key={skillIndex}
                            className="text-sm flex items-center"
                          >
                            <span className="w-1 h-1 bg-white rounded-full mr-3" />
                            {skill}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )
                )}
              </div>
              <h2 className="text-2xl font-bold mb-6">
                <span>{futureRoles?.[1]?.Title || "Unknown"}</span>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const FooterCareerMap = ({ futureRoles, requiredSkills, skillCategories }) => {
  const [careerGoal, setCareerGoal] = useState("");
  const [roadmap, setRoadmap] = useState({
    futureRoles,
    requiredSkills,
    skillCategories,
  });
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.post(
        `${SERVER_URL}/api/v1/career-gpt/get-basic-roadmaps`,
        { careerGoal }
      );
      setRoadmap(res.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching roadmap:", error);
      setLoading(false);
    }
  };

  return (
    <div className="mt-8 mx-auto max-w-7xl  text-white">
      {/* <div className="relative mb-6">
        <input
          type="text"
          placeholder="Search for career paths (e.g., Web3 Full Stack Developer)..."
          className="w-full bg-[#D9D9D91C] border border-white/30 rounded-2xl px-5 py-2 text-white placeholder-white/50 focus:outline-none focus:border-[#10F2EE] placeholder:italic placeholder:text-sm"
          value={careerGoal}
          onChange={(e) => setCareerGoal(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        />
        <button
          className="absolute right-2 top-1/2 -translate-y-1/2 bg-[#10F2EE] text-gray-900 px-4 py-1 rounded-full hover:bg-[#0DCCC9] transition-colors"
          onClick={handleSearch}
          disabled={loading}
        >
          {loading ? "Searching..." : "Search"}
        </button>
      </div> */}

      {loading ? (
          <div className=' fixed inset-0 flex items-center justify-center bg-black/85 z-50'>
<div class="loader-wrapper">
  <span class="loader-letter">L</span>
  <span class="loader-letter">o</span>
  <span class="loader-letter">a</span>
  <span class="loader-letter">d</span>
  <span class="loader-letter">i</span>
  <span class="loader-letter">n</span>
  <span class="loader-letter">g</span>

  <div class="loader"></div>
</div>
</div>
      ) : (
        roadmap && (
          <div className="bg-[#1B1A1AB8] rounded-xl text-white px-2 md:px-3 py-12 m-2 sm:m-7">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                {/* Left */}
                <div>
                  <h2 className="text-2xl font-bold mb-6">
                    Career <span className="text-yellow-400">Map</span>
                  </h2>

                   <div className="relative mb-6">
        <input
          type="text"
          placeholder="Search for career paths (e.g., Web3 Full Stack Developer)..."
          className="w-full bg-[#D9D9D91C] border border-white/30 rounded-2xl px-5 py-2 text-white placeholder-white/50 focus:outline-none focus:border-[#10F2EE] placeholder:italic placeholder:text-sm"
          value={careerGoal}
          onChange={(e) => setCareerGoal(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        />
        <button
          className="absolute right-2 top-1/2 -translate-y-1/2 bg-[#10F2EE] text-gray-900 px-4 py-1 font-medium text-sm rounded-lg hover:bg-[#0DCCC9] transition-colors"
          onClick={handleSearch}
          disabled={loading}
        >
          {loading ? "Searching..." : "Search"}
        </button>
      </div>
                  <div className="space-y-4 h-[28rem] overflow-y-auto ">
                    {roadmap.futureRoles?.map((role, index) => (
                      <div
                        key={index}
                        className="rounded-lg p-4 border border-gray-700"
                      >
                        <h3 className="font-semibold mb-2">
                          Role:{" "}
                          <span className="font-light ml-2">{role.Title}</span>
                        </h3>
                        <div className="space-y-2">
                          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
                            <span className="font-semibold">
                              Average Salary:
                            </span>
                            <span className="font-light">
                              {role.SalaryRange}
                            </span>
                          </div>
                          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
                            <span className="font-semibold">
                              Market Trends:
                            </span>
                            <span className="font-light">
                              {role.MarketTrends}
                            </span>
                          </div>
                          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
                            <span className="font-semibold">Key Skills:</span>
                            <span className="font-light">
                              {roadmap.requiredSkills
                                ?.slice(0, 3)
                                .map((s) => s.skill)
                                .join(", ")}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right */}
                <div className="bg-[#4747474F] rounded-xl p-5">
                  <div className="flex flex-col items-center justify-start">
                    <h2 className="text-2xl font-bold mb-6">
                      <span>
                        {roadmap.futureRoles?.[0]?.Title || "Career Path"}
                      </span>
                    </h2>
                    <div className="w-full max-h-[25rem] overflow-y-auto text-white flex flex-col items-center space-y-5 relative">
                      {/* <div className="absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-px bg-white/50" /> */}
                      {Object.entries(roadmap.skillCategories || {}).map(
                        ([area, skills], index) => (
                          <div
                            key={index}
                            className="flex items-start justify-between w-full gap-4 relative z-10"
                          >
                            <div className="w-[45%] text-white">
                              <h3 className="font-semibold mb-2">{area}</h3>
                            </div>
                            <div className="flex flex-col items-center justify-center relative">
                              <div className="w-5 h-5 rounded-full border-[3px] border-[#09FF0087] flex items-center justify-center shadow-[0_0_6px_#0DFF42] z-20 bg-[#262626] ">
                                <div className="w-2 h-2 bg-[#0DFF42] rounded-full z-20 " />
                              <div className=" bg-white w-px absolute left-1/2 z-0 h-20 "/>
                              </div>
                            </div>
                            <ul className="w-[45%] sm:pl-10 pl-0 text-white space-y-2">
                              {skills.map((skill, skillIndex) => (
                                <li
                                  key={skillIndex}
                                  className="text-sm flex items-center"
                                >
                                  <span className="w-1 h-1 bg-white rounded-full mr-3" />
                                  {skill}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )
                      )}
                    </div>
                    <h2 className="text-2xl font-bold mt-6">
                      <span>
                        {roadmap.futureRoles?.[1]?.Title || "Next Career Path"}
                      </span>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default CareerRoadmap;
